import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px 0 20px 0;;
  width: 100%;
  height: auto;
  border-radius: 0px 10px 0 0;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px 0 0 5px;
  }
`;

const Dropdown = styled.select`
  border-radius: 5px;
  margin-right: 20px;
  border: none;
  font-weight: bold;
  padding: 5px;
`;

const ContentContainer = styled.div`
  font-size: 14px;
  margin-left: 20px;
  display: flex;
  flex-direction: column;

  p {
    margin-bottom: 10px;
  }

  h4 {
    color: gray;
    margin-bottom: 5px;
  }

  table {
    font-size: 14px;
    transition: 0.3s;

    @media (max-width: 768px) {
    font-size: 12px;
  }
  }


`;

export const ContentContainerAddress = styled.div`
  font-size: 14px;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px;

  p {
    margin-bottom: 10px;
  }

  h4 {
    color: gray;
    margin-bottom: 5px;
  }
`;

const ContainerWithLabel = styled.div`
  top: 30em;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
`;

const Label = styled.div`
  width: 20%;
  color: #f97316;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    width: 50%;
    letter-spacing: 1px;
    line-height: 1.2;
  }
`;

const TtitleDirectory = styled.div`
  display: flex;
  font-weight: bold;

  p {
    background: rgba(255, 255, 255, 0.8);
    padding: 10px 40px;
    border-radius: 10px 10px 0 0;
  }

  p:nth-child(1) {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);  
  }

  p:nth-child(2) {
    background-color: #e5721b;
    color: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1, 0.8);
    cursor: pointer;


  &:hover {
    background: #c55a14;
  }
  }
`;
const data = {
  Guatemala: [
    {
      name: "Javier Cisneros",
      address: "15 Av. 2-57 Zona 6, Guatemala",
      phone: "2254-9471",
    },
    {
      name: "Aura Rodas",
      address: "Av. Reforma 3-48 Zona 9, Edificio Ángel, Oficina 104",
      phone: "23345602",
    },
    {
      name: "Aura Rodas",
      address: "Av. Reforma 3-48 Zona 9, Edificio Ángel, Oficina 104",
      phone: "23345602",
    },
    {
      name: "Bianca De La Cruz",
      address: "6 Avenida 14-00 Zona 11",
      phone: "58321760",
    },
    {
      name: "Jorge Daniel Morales",
      address:
        "2a Calle 24-00 Zona 15, Vista Hermosa II, Edificio Domani, 8vo Nivel, Oficina 810",
      phone: "6645-5942",
    },
    {
      name: "Luis Rejopachi",
      address: "2a Calle A 6-28 Zona 10, Edificio Verona, Oficina 111",
      phone: "5304-8061",
    },
    {
      name: "Haroldo Cabrera",
      address: "6 Avenida A 13-25 Zona 9",
      phone: "22593232",
    },
    {
      name: "Jorge Palacios",
      address: "6 Avenida A 13-25 Zona 9",
      phone: "22593232",
    },
    {
      name: "Ronald Castellanos",
      address: "Edif. Tikal Futura, Torre Sol, Oficina 11D",
      phone: "2475-0918 / 2440-9703",
    },
    {
      name: "Mayra De Castellanos",
      address: "Edif. Tikal Futura, Torre Sol, Oficina 11D",
      phone: "2475-0918 / 2440-9703",
    },
    {
      name: "Gerardo Godínez",
      address:
        "Calzada Roosevelt 22-43 Zona 11, C.C. Tikal Futura, Torre Luna, Nivel 10, Oficina 10B",
      phone: "24403817",
    },
    {
      name: "Ricardo Estrada",
      address: "5 Calle 0-46 Zona 1",
      phone: "22180707",
    },
  ],
  "San Marcos": [
    {
      name: "José Danilo López",
      address: "1 Calle 6-56 Zona 1, Cantón San Juan De Dios",
      phone: "77771465",
    },
    {
      name: "Justo González",
      address: "3 Calle 11 Av. Zona 1, Cantón Barrios",
      phone: "7776-9245",
    },
  ],
  Quetzaltenango: [
    {
      name: "Fernando Tebalan",
      address: "Diagonal 2 4-27 Zona 4, Barrio Colombita",
      phone: "77757619",
    },
    {
      name: "Byron Rosales",
      address:
        "13 Avenida 6-20 Zona 3, Edificio Médico San Lucas, Clínica 105, Primer Nivel",
      phone: "77637610",
    },
  ],
  Huehuetenango: [
    {
      name: "Juan José Palacios",
      address: "13 Calle 5-48 Zona 5, Colonia El Bosque, Huehuetenango",
      phone: "7762-7677",
    },
    {
      name: "Katherine Palacios",
      address: "13 Calle 5-48 Zona 5, Colonia El Bosque, Huehuetenango",
      phone: "7762-7677",
    },
    {
      name: "Jimena López",
      address: "6a Calle 9-58 Zona 1, Huehuetenango",
      phone: "7762-7677",
    },
  ],
  Jutiapa: [
    {
      name: "Gerardo Joel Arrivillaga",
      address: "",
      phone: "",
    },
  ],
  Sacatepéquez: [
    {
      name: "Glenda Martínez",
      address: "2a Calle Poniente No. 40, Antigua Guatemala",
      phone: "",
    },
  ],
};

const DirectoryComponent = () => {
  const [selectedCountry, setSelectedCountry] = useState("Guatemala");

  const handleChange = (event) => {
    setSelectedCountry(event.target.value);
  };

  return (
    <ContainerWithLabel>
      <TtitleDirectory>
        <p>+ Directorio Médico</p>
        <p>Contáctanos</p>
      </TtitleDirectory>
      <Container>
        <ContentContainer>
          <h4>Departamento</h4>
          <Dropdown value={selectedCountry} onChange={handleChange}>
            {Object.keys(data).map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </Dropdown>
        </ContentContainer>

        <ContentContainer style={{ width: "90%" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ textAlign: "left" }}>
                <th style={{ padding: "10px", borderRadius: "10px 0 0 0" }}>
                  Nombre
                </th>
                <th style={{ padding: "10px" }}>Dirección</th>
                <th style={{ padding: "10px", borderRadius: "0 10px 0 0" }}>
                  Teléfono
                </th>
              </tr>
            </thead>
            <tbody>
              {data[selectedCountry].map((item, index) => (
                <tr key={index}>
                  <td
                    style={{ padding: "10px", borderBottom: "1px solid #ddd" }}
                  >
                    <b>{item.name}</b>
                  </td>
                  <td
                    style={{ padding: "10px", borderBottom: "1px solid #ddd" }}
                  >
                    {item.address}
                  </td>
                  <td
                    style={{ padding: "10px", borderBottom: "1px solid #ddd" }}
                  >
                    {item.phone}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ContentContainer>
      </Container>
    </ContainerWithLabel>
  );
};

export default DirectoryComponent;
